export const LOAN_MODEL_KEYS = {
  /**
   * Existing
   */
  loanPurpose: "loanPurpose",
  loanProductType: "loanProductType",
  /**
   * New
   */
  hasClosedWithLenderBefore: "hasClosedWithLenderBefore",
  isBrokeredLoan: "isBrokeredLoan",
};
